export default __webpack_public_path__ + "images/Mastercard.4c7ab86099c9156497ccbfd5bc613950.svg";